import { BsPlusLg } from "react-icons/bs";
import { FiMinus } from "react-icons/fi";
import Container from "../../../components/layout/Container";

const BusinessMap = () => {
  return (
    <Container>
      <div className="mt-8 h-[352px] w-[934px] rounded">
        <div>
          <div>
            <h5 className="font-pop text-xl font-bold text-primary">
              Map Location
            </h5>
          </div>
          <div className="relative mt-6 h-[310px] w-[933px] rounded">
            <img src="assets/images/business_details/map2.png" alt="map2" />
            <div className="absolute top-2.5 left-2.5 flex flex-col">
              <button className="mb-1 bg-[#1D9BF0] py-6 px-4 text-white">
                <BsPlusLg className="w-4 h-4" />
              </button>
              <button className="bg-[#1D9BF0] py-6 px-4 text-white">
                <FiMinus className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BusinessMap;
